module.exports = __webpack_public_path__ + "img/epr@2x.0e629164.webp";